/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Flex as AntDFlex } from 'antd';
import { CSSProperties } from 'react';

import { useTheme } from '@/hooks/useTheme';
import { TShirtSize, tokens } from '@/theme';

export type ContainerProps = {
  children?: React.ReactNode;
  className?: string;
  gap?: TShirtSize | 'none';
  padding?: TShirtSize;
  horizontal?: boolean;
  justify?: React.CSSProperties['justifyContent'];
  full?: boolean;
  style?: CSSProperties;
};

export function Container({ className, gap, horizontal, style, children, justify, padding, full }: ContainerProps) {
  const theme = useTheme();
  const gapSize = gap === 'none' ? 0 : tokens.size.space[gap || 'md'];
  const paddingPx = padding ? tokens.size.space[padding] : undefined;

  const heightStyles: React.CSSProperties = {
    width: horizontal && full ? '100%' : undefined,
    height: !horizontal && full ? '100%' : undefined,
  };

  return (
    <AntDFlex
      className={className}
      vertical={!horizontal}
      gap={gapSize}
      justify={justify}
      align="flex-start"
      style={{
        padding: paddingPx,
        backgroundColor: theme.antdTokens.colorBgLayout,
        ...heightStyles,
        ...style,
      }}
    >
      {children}
    </AntDFlex>
  );
}
export type ContainerFixedProps = {
  children?: React.ReactNode;
};

Container.Fixed = function ContainerFixed({ children }: ContainerFixedProps) {
  return <div style={{ flexShrink: 1, flexGrow: 0, width: '100%' }}>{children}</div>;
};

export type ContainerExpandProps = {
  children?: React.ReactNode;
};

Container.Expand = function ContainerExpand({ children }: ContainerExpandProps) {
  return (
    <div
      style={{
        flexBasis: '0px',
        flexShrink: 0,
        flexGrow: 1,
        width: '100%',
        overflow: 'auto',
      }}
    >
      {children}
    </div>
  );
};
